export default "__VITE_ASSET__CJW6T1oN__"